// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"cf41e507","453":"48182235","843":"926b2213"}[chunkId] + ".chunk.js";
};